import { Controller } from "stimulus"
import { Turbo } from "@hotwired/turbo-rails";
import { turbo_fetch } from "../helpers";

const countries = {'Afghanistan': "AF", 'Aland Islands': "AX", 'Albania': "AL", 'Algeria': "DZ", 'American Samoa': "AS", 'Andorra': "AD", 'Angola': "AO", 'Anguilla': "AI", 'Antarctica': "AQ", 'Antigua and Barbuda': "AG", 'Argentina': "AR", 'Armenia': "AM", 'Aruba': "AW", 'Australia': "AU", 'Austria': "AT", 'Azerbaijan': "AZ", 'Bahamas': "BS", 'Bahrain': "BH", 'Bangladesh': "BD", 'Barbados': "BB", 'Belarus': "BY", 'Belgium': "BE", 'Belize': "BZ", 'Benin': "BJ", 'Bermuda': "BM", 'Bhutan': "BT", 'Bolivia': "BO", 'Bonaire, Saint Eustatius and Saba': "BQ", 'Bosnia and Herzegovina': "BA", 'Botswana': "BW", 'Bouvet Island': "BV", 'Brazil': "BR", 'British Indian Ocean Territory': "IO", 'British Virgin Islands': "VG", 'Brunei': "BN", 'Bulgaria': "BG", 'Burkina Faso': "BF", 'Burundi': "BI", 'Cambodia': "KH", 'Cameroon': "CM", 'Canada': "CA", 'Cape Verde': "CV", 'Cayman Islands': "KY", 'Central African Republic': "CF", 'Chad': "TD", 'Chile': "CL", 'China': "CN", 'Christmas Island': "CX", 'Cocos Islands': "CC", 'Colombia': "CO", 'Comoros': "KM", 'Cook Islands': "CK", 'Costa Rica': "CR", 'Croatia': "HR", 'Cuba': "CU", 'Curacao': "CW", 'Cyprus': "CY", 'Czech Republic': "CZ", 'Democratic Republic of the Congo': "CD", 'Denmark': "DK", 'Djibouti': "DJ", 'Dominica': "DM", 'Dominican Republic': "DO", 'East Timor': "TL", 'Ecuador': "EC", 'Egypt': "EG", 'El Salvador': "SV", 'Equatorial Guinea': "GQ", 'Eritrea': "ER", 'Estonia': "EE", 'Ethiopia': "ET", 'Falkland Islands': "FK", 'Faroe Islands': "FO", 'Fiji': "FJ", 'Finland': "FI", 'France': "FR", 'French Guiana': "GF", 'French Polynesia': "PF", 'French Southern Territories': "TF", 'Gabon': "GA", 'Gambia': "GM", 'Georgia': "GE", 'Germany': "DE", 'Ghana': "GH", 'Gibraltar': "GI", 'Greece': "GR", 'Greenland': "GL", 'Grenada': "GD", 'Guadeloupe': "GP", 'Guam': "GU", 'Guatemala': "GT", 'Guernsey': "GG", 'Guinea': "GN", 'Guinea-Bissau': "GW", 'Guyana': "GY", 'Haiti': "HT", 'Heard Island and McDonald Islands': "HM", 'Honduras': "HN", 'Hong Kong': "HK", 'Hungary': "HU", 'Iceland': "IS", 'India': "IN", 'Indonesia': "ID", 'Iran': "IR", 'Iraq': "IQ", 'Ireland': "IE", 'Isle of Man': "IM", 'Israel': "IL", 'Italy': "IT", 'Ivory Coast': "CI", 'Jamaica': "JM", 'Japan': "JP", 'Jersey': "JE", 'Jordan': "JO", 'Kazakhstan': "KZ", 'Kenya': "KE", 'Kiribati': "KI", 'Kosovo': "XK", 'Kuwait': "KW", 'Kyrgyzstan': "KG", 'Laos': "LA", 'Latvia': "LV", 'Lebanon': "LB", 'Lesotho': "LS", 'Liberia': "LR", 'Libya': "LY", 'Liechtenstein': "LI", 'Lithuania': "LT", 'Luxembourg': "LU", 'Macao': "MO", 'Macedonia': "MK", 'Madagascar': "MG", 'Malawi': "MW", 'Malaysia': "MY", 'Maldives': "MV", 'Mali': "ML", 'Malta': "MT", 'Marshall Islands': "MH", 'Martinique': "MQ", 'Mauritania': "MR", 'Mauritius': "MU", 'Mayotte': "YT", 'Mexico': "MX", 'Micronesia': "FM", 'Moldova': "MD", 'Monaco': "MC", 'Mongolia': "MN", 'Montenegro': "ME", 'Montserrat': "MS", 'Morocco': "MA", 'Mozambique': "MZ", 'Myanmar': "MM", 'Namibia': "NA", 'Nauru': "NR", 'Nepal': "NP", 'Netherlands': "NL", 'New Caledonia': "NC", 'New Zealand': "NZ", 'Nicaragua': "NI", 'Niger': "NE", 'Nigeria': "NG", 'Niue': "NU", 'Norfolk Island': "NF", 'North Korea': "KP", 'Northern Mariana Islands': "MP", 'Norway': "NO", 'Oman': "OM", 'Pakistan': "PK", 'Palau': "PW", 'Palestinian Territory': "PS", 'Panama': "PA", 'Papua New Guinea': "PG", 'Paraguay': "PY", 'Peru': "PE", 'Philippines': "PH", 'Pitcairn': "PN", 'Poland': "PL", 'Portugal': "PT", 'Puerto Rico': "PR", 'Qatar': "QA", 'Republic of the Congo': "CG", 'Reunion': "RE", 'Romania': "RO", 'Russia': "RU", 'Rwanda': "RW", 'Saint Barthelemy': "BL", 'Saint Helena': "SH", 'Saint Kitts and Nevis': "KN", 'Saint Lucia': "LC", 'Saint Martin': "MF", 'Saint Pierre and Miquelon': "PM", 'Saint Vincent and the Grenadines': "VC", 'Samoa': "WS", 'San Marino': "SM", 'Sao Tome and Principe': "ST", 'Saudi Arabia': "SA", 'Senegal': "SN", 'Serbia': "RS", 'Seychelles': "SC", 'Sierra Leone': "SL", 'Singapore': "SG", 'Sint Maarten': "SX", 'Slovakia': "SK", 'Slovenia': "SI", 'Solomon Islands': "SB", 'Somalia': "SO", 'South Africa': "ZA", 'South Georgia and the South Sandwich Islands': "GS", 'South Korea': "KR", 'South Sudan': "SS", 'Spain': "ES", 'Sri Lanka': "LK", 'Sudan': "SD", 'Suriname': "SR", 'Svalbard and Jan Mayen': "SJ", 'Swaziland': "SZ", 'Sweden': "SE", 'Switzerland': "CH", 'Syria': "SY", 'Taiwan': "TW", 'Tajikistan': "TJ", 'Tanzania': "TZ", 'Thailand': "TH", 'Togo': "TG", 'Tokelau': "TK", 'Tonga': "TO", 'Trinidad and Tobago': "TT", 'Tunisia': "TN", 'Turkey': "TR", 'Turkmenistan': "TM", 'Turks and Caicos Islands': "TC", 'Tuvalu': "TV", 'U.S. Virgin Islands': "VI", 'Uganda': "UG", 'Ukraine': "UA", 'United Arab Emirates': "AE", 'United Kingdom': "GB", 'United States': "US", 'United States Minor Outlying Islands': "UM", 'Uruguay': "UY", 'Uzbekistan': "UZ", 'Vanuatu': "VU", 'Vatican': "VA", 'Venezuela': "VE", 'Vietnam': "VN", 'Wallis and Futuna': "WF", 'Western Sahara': "EH", 'Yemen': "YE", 'Zambia': "ZM", 'Zimbabwe': "ZW"};

export default class extends Controller {
  static targets = ["locale", "locations", "tourType", "season"];

  async connect() {
    this.updateBasketHeader()
    let urlParams;
    (window.onpopstate = function () {
      let match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

      urlParams = {};
      while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);
    })();
    let plocId = document.getElementById('plocId');
    if ( plocId ) {
      if ( urlParams.plocId ) {
        plocId.value = urlParams.plocId;
      }
      else {
        let query = window.location.pathname.split('/');
        let island = false;
        query.forEach(element => {
          switch (element) {
              case 'gran-canaria':
                island = true;
                plocId.value = '1';
                break;
              case 'tenerife':
                island = true;
                plocId.value = '2';
                break;
              case 'lanzarote':
                island = true;
                plocId.value = '3';
                break;        
          }
        });
        if ( !island ) {
          plocId.value = 1;
        }
      }
    }
    let tour_type = document.getElementById('tourType');
    if ( tour_type ) {
      if ( urlParams.tour_type ){
        tour_type.value = urlParams.tour_type;
      }
    }

    const island = sessionStorage.getItem('plocId');
    const type = sessionStorage.getItem('type');
    const season = sessionStorage.getItem('season');
    const level = sessionStorage.getItem('level');
    if ( island ) {
      if ( plocId )
        plocId.value = island;
    }
    if ( type ) {
      if ( tour_type )
        tour_type.value = type;
    }
    if ( season ) {
      let season_cont = document.getElementById('season');
      if ( season_cont )
        season_cont.value = season;
    }
    await this.filterLevels(null);

    if ( level ) {
      let level_cont = document.getElementById('tourLevel');
      if ( level_cont )
        level_cont.value = level;
    }
    this.filterTours(null);

    const tour = document.getElementById('view-tour');
    if ( tour ) {
      const info = JSON.parse(tour.dataset.info);
      let userInfo = document.getElementById('user-info');
      let user = {};
      if ( userInfo ) {
        userInfo = userInfo.dataset;
        user = {
          email: userInfo.email,
          first_name: userInfo.first_name,
          last_name: userInfo.last_name,
          phone_number: userInfo.phone_number,
          street: userInfo.street,
          city: userInfo.city,
          postal_code: userInfo.postal_code,
          country: userInfo.country
        }
      }
      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: "EUR",
          value: info.price_plain,
          items: [
            {
              item_id: info.tour_id,
              item_name: info.category_name,
              currency: "EUR",
              item_category: info.category_name,
              location_id: info.loc_id,
              price: info.price_plain,
              quantity: 1
            }
          ],
          enhanced_conversion_data: user
        }
      });
      console.log('DATALAYER - view_item', dataLayer);
    }
  }

  filterLevels(event) {
    let tourType = document.getElementById('tourType');
    if ( tourType ) {
      tourType = tourType.value;
    } else {
      return;
    }
    let season = document.getElementById('season');
    if ( season )
      season = season.value;
    else
      return;
    switch ( tourType ) {
      case '3':
        document.getElementById('rbike').classList.remove('hidden');
        document.getElementById('mbike').classList.add('hidden');
        document.getElementById('embike').classList.add('hidden');
        document.getElementById('trekking').classList.add('hidden');
        break;
      case '2':
        document.getElementById('mbike').classList.remove('hidden');
        document.getElementById('rbike').classList.add('hidden');
        document.getElementById('embike').classList.add('hidden');
        document.getElementById('trekking').classList.add('hidden');
        break;
      case '14':
        document.getElementById('trekking').classList.remove('hidden');
        document.getElementById('rbike').classList.add('hidden');
        document.getElementById('mbike').classList.add('hidden');
        document.getElementById('embike').classList.add('hidden');
        break;
      case '15':
        document.getElementById('embike').classList.remove('hidden');
        document.getElementById('rbike').classList.add('hidden');
        document.getElementById('mbike').classList.add('hidden');
        document.getElementById('trekking').classList.add('hidden');
        break;
      default:
        document.getElementById('mbike').classList.add('hidden');
        document.getElementById('rbike').classList.add('hidden');
        document.getElementById('embike').classList.add('hidden');
        document.getElementById('trekking').classList.add('hidden');
    }
    let select = document.getElementById("tourLevel");
    for (let i = 0; i < select.options.length; i++ ) {
      select.options[i].classList.add('hidden');
      select.options[i].setAttribute('disabled', 'disabled');
      if ( (select.options[i].value == '') || ((tourType && (select.options[i].dataset.tour_type == tourType)) && (season && (select.options[i].dataset.season == season))) ) {
        select.options[i].classList.remove('hidden');
        select.options[i].removeAttribute('disabled');
      }
    }
    select.value = '';
    this.filterTours();
  }

  filterTours(event) {
    let tour_type;
    let level
    let plocId
    let season
    if (document.getElementById('tourType')) tour_type = document.getElementById('tourType').value;
    if (document.getElementById('tourLevel')) level = document.getElementById('tourLevel').value;
    if (document.getElementById('plocId')) plocId = document.getElementById('plocId').value;
    if (document.getElementById('season')) season = document.getElementById('season').value;

    const lang = this.localeTarget.value;
    let url = `/${lang}/booking_process/finder/tours?tour_type=${tour_type}&season=${season}&level=${level}&plocId=${plocId}`;

    let spinner = document.getElementById('spinner');
    if ( spinner )
      spinner.classList.remove('hidden');
    let flag = false;
    document.addEventListener("framed", this.tours_layer);
    turbo_fetch(url);
  }

  saveFilters(event) {
    const island = document.getElementById('plocId');
    const type = document.getElementById('tourType');
    const season = document.getElementById('season');
    const level = document.getElementById('tourLevel');
    if ( island && island.value )
      sessionStorage.setItem('island', island.value);
    if ( type && type.value )
      sessionStorage.setItem('type', type.value);
    if ( season && season.value )
      sessionStorage.setItem('season', season.value);
    if ( level && level.value )
      sessionStorage.setItem('level', level.value);
  }

  closeBasket(event) {
    let terms = document.getElementById('terms');
    if ( terms.checked ) {
      let basket = sessionStorage.getItem('basket');
      let url = `/booking_process/close_basket?basket=${basket}`;
      fetch(url)
      .then(response => response.json())
      .then((data) => {
        sessionStorage.removeItem('basket');
        let modal = document.getElementById('modal');
        modal.classList.remove('hidden');
      });
    }
  }

  finish(event) {
    window.location.href = '/';
  }

  updateBasketHeader() {
    let basket = sessionStorage.getItem("basket");
    let count = 0;
    if (basket) {
      const url = `/booking_process/get_basket/${basket}`;
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            data.OrderPosition.forEach((element) => {
              if (element.prodType == "R" || element.prodType == "T") count++;
            });
            document.getElementById("cart1").innerHTML = count;
            document.getElementById("cart2").innerHTML = count;
          }
        });
    } else {
      let baskets = sessionStorage.getItem("baskets");
      if (baskets) {
        count = JSON.parse(baskets).length;
        document.getElementById("cart1").innerHTML = count;
        document.getElementById("cart2").innerHTML = count;
      }
    }
  }

  pickBike(event) {
    let button = document.getElementById('addToCart');
    let select = document.getElementById('pedal');
    select.forEach(option => {
      select.remove(option);
    });
    let bike = JSON.parse(event.target.dataset.bike);
    let price = document.getElementById('price');
    let image = document.getElementById('image');
    button.dataset.model = bike.modelId;
    button.dataset.total = bike.price;
    price.innerHTML = bike.price;

    image.src = bike.image;
    let form = document.getElementById('form');
    if ( bike.pedals ) {
      form.classList.remove('hidden');
      let selected = event.target.dataset.selected;
      let pedals = bike.pedals;
      pedals.forEach(pedal => {
        let option = document.createElement("option");
        option.text = pedal.pedalName;
        option.value = pedal.pedalId;
        if ( pedal.pedalId == selected ) {
          option.selected = 'selected';
        }
        select.appendChild(option);
      });
    }
    else {
      form.classList.add('hidden');
    }

    document.getElementById('modal').classList.remove('hidden');
    document.body.classList.add('overflow-hidden');

    //document.getElementById('spinner_modal').classList.remove('hidden');
    
  }

  addToCart(event) {
    let button;
    let path = event.path || (event.composedPath && event.composedPath());
    for (let el of path) {
      if (el.dataset.model !== undefined && el.dataset.model !== "") {
        button = el;
        break;
      }
    };

    let elem = document.getElementById('addToCart');
    elem.classList.remove('hidden');
    elem = elem.dataset;
    let tour_data = JSON.parse(elem.info);
    let errors = false;
    let name = document.getElementById('name');
    let surname = document.getElementById('surname');
    let weight = document.getElementById('weight');
    let height = document.getElementById('height');
    let pedal = document.getElementById('pedal');
    let saddle = document.getElementById('saddle');
    let date = document.getElementById('date').value;
    let modelId = button.dataset.model;
    let tourId = button.dataset.tour;
    let total = button.dataset.total;
    let form = document.getElementById('form');
    let location = button.dataset.location;
    let spinner_modal = document.getElementById('spinner_modal');
    let spinner_text = document.getElementById("spinner-text");

    if ( !name.value ) {
      name.classList.add('error');
      errors = true;
    }
    else
      name.classList.remove('error');
      
    if ( !surname.value ) {
      surname.classList.add('error');
      errors = true;
    }
    else
      surname.classList.remove('error');

    if ( errors )
      return true;
    
    name = name.value;
    surname = surname.value;

    let url = `/booking_tours/add_to_basket?name=${name}&surname=${surname}&tour=${tourId}&model=${modelId}&loc=${location}&total=${total}&date=${date}`;

    if ( form && !form.classList.contains('hidden') ) {
      if ( weight ) {
        if ( weight.value )
          url += `&weight=${weight.value}`;
        else
          errors = true;
      }

      if ( height ) {
        if ( height.value )
          url += `&height=${height.value}`;
        else
          errors = true;
      }

      if ( pedal ) {
        if ( pedal.value )
          url += `&pedal=${pedal.value}`;
        else
          errors = true;
      }

      if ( saddle ) {
        if ( saddle.value )
          url += `&saddle=${saddle.value}`;
      }

      if ( errors ) {
        return true;
      }
    }

    if (spinner_modal) {
      spinner_text.classList.remove('hidden')
      spinner_modal.classList.remove('hidden');
    }

    let basket = sessionStorage.getItem('basket');

    if ( basket && basket !== 'undefined' )
      url += `&basket=${basket}`;    

    document.getElementById('addToCart').classList.add('hidden');

    console.log(url);
    fetch(url)
      .then(response => response.json())
      .then((data) => {
        if (!data || data.unavailable) {
          console.log(data);
          document.getElementById("unavailable").classList.remove("hidden");
          document.getElementById("addToCart").classList.remove("hidden");
          spinner_text.classList.add("hidden");
        }
        else {
          document.getElementById('continue').classList.remove('hidden');
          document.getElementById('close').classList.remove('hidden');
          sessionStorage.setItem('basket', data.basket);
          this.updateBasketHeader();

          let userInfo = document.getElementById('user-info');
          let user = {};
          if ( userInfo ) {
            userInfo = userInfo.dataset;
            user = {
              email: userInfo.email,
              first_name: userInfo.first_name,
              last_name: userInfo.last_name,
              phone_number: userInfo.phone_number,
              street: userInfo.street,
              city: userInfo.city,
              postal_code: userInfo.postal_code,
              country: userInfo.country
            }
          }
          dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
          dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: "EUR",
              value: parseFloat(total),
              items: [{
                item_id: tour_data.tour_id.toString(),
                item_name: tour_data.tour_name,
                index: 0,
                item_category: tour_data.category_name,
                location_id: tour_data.loc_id.toString(),
                price: parseFloat(total),
                quantity: 1
              }],
              enhanced_conversion_data: user
            }
          });
          console.log('DATALAYER - add_to_cart', dataLayer);

        }
        spinner_modal.classList.add("hidden");
        spinner_text.classList.add("hidden");
      })
      .catch(error => {
        if ( spinner_modal )
          spinner_modal.classList.add('hidden');
        console.error(error);
        document.getElementById('addToCart').classList.remove('hidden');
      });
  }

  addToCartAgent(event) {
    let elem = document.getElementById('addToCart');
    elem.classList.remove('hidden');
    elem = elem.dataset;
    let tour_data = JSON.parse(elem.info);
    let errors = false;
    let name = document.getElementById('name');
    let surname = document.getElementById('surname');
    let weight = document.getElementById('weight');
    let height = document.getElementById('height');
    let pedal = document.getElementById('pedal');
    let saddle = document.getElementById('saddle');
    let date = document.getElementById('date').value;
    let modelId = event.target.dataset.model;
    let tourId = event.target.dataset.tour;
    let total = event.target.dataset.total;
    let form = document.getElementById('form');
    let location = event.target.dataset.location;
    let spinner_modal = document.getElementById('spinner_modal');
    let mail = document.getElementById("rider-mail");
    let phone = document.getElementById("rider-phone");

    if ( !name.value ) {
      name.classList.add('error');
      errors = true;
    }
    else
      name.classList.remove('error');
      
    if ( !surname.value ) {
      surname.classList.add('error');
      errors = true;
    }
    else
      surname.classList.remove('error');

    if (!mail.value) {
      mail.classList.add("error");
      errors = true;
    } else mail.classList.remove("error");

    if (!phone.value) {
      phone.classList.add("error");
      errors = true;
    } else phone.classList.remove("error");

    if ( errors )
      return true;
    
    name = name.value;
    surname = surname.value;
    phone = phone.value;
    mail = mail.value

    let url = `/agents/add_tour_to_basket?name=${name}&surname=${surname}&tour=${tourId}&model=${modelId}&loc=${location}&total=${total}&date=${date}&mail=${mail}&phone=${phone}`;

    if ( form && !form.classList.contains('hidden') ) {
      if ( weight ) {
        if ( weight.value )
          url += `&weight=${weight.value}`;
        else
          errors = true;
      }

      if ( height ) {
        if ( height.value )
          url += `&height=${height.value}`;
        else
          errors = true;
      }

      if ( pedal ) {
        if ( pedal.value )
          url += `&pedal=${pedal.value}`;
        else
          errors = true;
      }

      if ( saddle ) {
        if ( saddle.value )
          url += `&saddle=${saddle.value}`;
      }

      if ( errors ) {
        return true;
      }
    }

    if ( spinner_modal )
      spinner_modal.classList.remove('hidden');

    let basket = sessionStorage.getItem('basket');

    if ( basket && basket !== 'undefined' )
      url += `&basket=${basket}`;    

    document.getElementById('addToCart').classList.add('hidden');

    fetch(url)
      .then(response => response.json())
      .then((data) => {
        if ( !data || data.unavailable ) {
          document.getElementById('unavailable').classList.remove('hidden');
          document.getElementById('addToCart').classList.remove('hidden');
        }
        else {
          document.getElementById('continue').classList.remove('hidden');
          document.getElementById('close').classList.remove('hidden');

          let storedBasket = sessionStorage.getItem("baskets");
          let basketArray = storedBasket ? JSON.parse(storedBasket) : [];
          basketArray.push(data.basket);
          let updatedBasket = JSON.stringify(basketArray);
          sessionStorage.setItem("baskets", updatedBasket);

          this.updateBasketHeader();

          let userInfo = document.getElementById('user-info');
          let user = {};
          if ( userInfo ) {
            userInfo = userInfo.dataset;
            user = {
              email: userInfo.email,
              first_name: userInfo.first_name,
              last_name: userInfo.last_name,
              phone_number: userInfo.phone_number,
              street: userInfo.street,
              city: userInfo.city,
              postal_code: userInfo.postal_code,
              country: userInfo.country
            }
          }
          dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
          dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: "EUR",
              value: parseFloat(total),
              items: [{
                item_id: tour_data.tour_id.toString(),
                item_name: tour_data.tour_name,
                index: 0,
                item_category: tour_data.category_name,
                location_id: tour_data.loc_id.toString(),
                price: parseFloat(total),
                quantity: 1
              }],
              enhanced_conversion_data: user
            }
          });
          console.log('DATALAYER - add_to_cart', dataLayer);

        }
        if ( spinner_modal )
          spinner_modal.classList.add('hidden');
      })
      .catch(error => {
        if ( spinner_modal )
          spinner_modal.classList.add('hidden');
        console.error(error);
        document.getElementById('addToCart').classList.remove('hidden');
      });
  }

  closeModal(event) {
    document.getElementById('modal').classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
    document.getElementById('addToCart').classList.remove('hidden');
    document.getElementById('continue').classList.add('hidden');
    document.getElementById('close').classList.add('hidden');
  }

  showTab(event) {
    event.preventDefault();
    event.stopPropagation();

    const param = event.target.dataset.container;

    let cont1 = document.getElementById('cont1');
    let conts1 = document.getElementsByClassName('cont1');
    let cont2 = document.getElementById('cont2');
    let conts2 = document.getElementsByClassName('cont2');
    let cont3 = document.getElementById('cont3');
    let conts3 = document.getElementsByClassName('cont3');
    let cont4 = document.getElementById('cont4');
    let conts4 = document.getElementsByClassName('cont4');
    let navContent = document.getElementsByClassName('nav-content');
    let navContentArray = Array.from(navContent);
    let navContentArrayLength = navContentArray.length;
    let i;

    for (i = 0; i < navContentArrayLength; i++) {
      navContentArray[i].classList.add('hidden');
    }				

    switch(param) {

      case 'cont1':
        for (i = 0; i < conts1.length; i++) {
          conts1[i].classList.remove('border-transparent','text-gray-500');
          conts1[i].classList.add('freemotion-border','freemotion-color');
          conts2[i].classList.remove('freemotion-border','freemotion-color');
          conts2[i].classList.add('border-transparent','text-gray-500');
          conts3[i].classList.remove('freemotion-border','freemotion-color');
          conts3[i].classList.add('border-transparent','text-gray-500');
          //conts4[i].classList.remove('freemotion-border','freemotion-color');
          //conts4[i].classList.add('border-transparent','text-gray-500');
        }
        cont1.classList.remove('hidden');
        break;
      case 'cont2':
        for (i = 0; i < conts2.length; i++) {
          conts1[i].classList.remove('freemotion-border','freemotion-color');
          conts1[i].classList.add('border-transparent','text-gray-500');
          conts2[i].classList.remove('border-transparent','text-gray-500');
          conts2[i].classList.add('freemotion-border','freemotion-color');
          conts3[i].classList.remove('freemotion-border','freemotion-color');
          conts3[i].classList.add('border-transparent','text-gray-500');
          //conts4[i].classList.remove('freemotion-border','freemotion-color');
          //conts4[i].classList.add('border-transparent','text-gray-500');
        }
        cont2.classList.remove('hidden');
        break;
      case 'cont3':
        for (i = 0; i < conts3.length; i++) {
          conts1[i].classList.remove('freemotion-border','freemotion-color');
          conts1[i].classList.add('border-transparent','text-gray-500');
          conts2[i].classList.remove('freemotion-border','freemotion-color');
          conts2[i].classList.add('border-transparent','text-gray-500');
          conts3[i].classList.remove('border-transparent','text-gray-500');
          conts3[i].classList.add('freemotion-border','freemotion-color');
          //conts4[i].classList.remove('freemotion-border','freemotion-color');
          //conts4[i].classList.add('border-transparent','text-gray-500');
        }
        cont3.classList.remove('hidden');
        break;
      /*case 'cont4':
        for (i = 0; i < conts4.length; i++) {
          conts1[i].classList.remove('freemotion-border','freemotion-color');
          conts1[i].classList.add('border-transparent','text-gray-500');
          conts2[i].classList.remove('freemotion-border','freemotion-color');
          conts2[i].classList.add('border-transparent','text-gray-500');
          conts3[i].classList.remove('freemotion-border','freemotion-color');
          conts3[i].classList.add('border-transparent','text-gray-500');
          conts4[i].classList.remove('border-transparent','text-gray-500');
          conts4[i].classList.add('freemotion-border','freemotion-color');
        }
        cont4.classList.remove('hidden');
        break;*/
    }
  }

  closeUnavailable(event) {
    document.getElementById('unavailable').classList.add('hidden');
  }

  step2(event) {
    let basket = sessionStorage.getItem('basket');
    if ( basket ) {

      let spinner = document.getElementById('spinner');
      if ( spinner )
        spinner.classList.remove('hidden');
      let spinner_modal = document.getElementById('spinner_modal');
      if ( spinner_modal )
        spinner_modal.classList.remove('hidden');
      document.addEventListener("turbo:before-fetch-response", function (e) {
        let selected = false;
        let interval = setInterval(function() {
          let select = document.getElementById("country");
          if (select) {
            clearInterval(interval);
            for (let key in countries) {
              let option = document.createElement("option");
              option.text = key;
              option.value = countries[key];
              if ( option.value === 'ES' ){
                option.id = 'es';
              }
              if ( select.dataset.country === countries[key] ){
                option.selected = 'selected';
                selected = true;
              }
              select.appendChild(option);
            }
            if ( !selected ) {
              let spain = document.getElementById('es');
              spain.setAttribute('selected', 'selected');
            }
          }
        }, 100);
      });
      const lang = this.localeTarget.value;
      window.location.href = `/${lang}/basket?basket=${basket}`;
    }
    
  }

  step2Agent() {
    let spinner = document.getElementById("spinner");
    if (spinner) spinner.classList.remove("hidden");
    let spinner_modal = document.getElementById("spinner_modal");
    if (spinner_modal) spinner_modal.classList.remove("hidden");
    const lang = this.localeTarget.value;
    window.location.href = `/${lang}/agents/baskets`;
  }

  toggleLogin(event) {
    let elem = document.getElementById("collapse");
    let elem2 = document.getElementById("session");
    elem.classList.toggle("hidden");
    elem2.classList.toggle("hidden");
  }

  showSpinner() {
    let spinner_modal = document.getElementById("spinner_modal");
    if (spinner_modal) spinner_modal.classList.remove('hidden')
  }

  tours_layer() {
    document.removeEventListener("framed", this.tours_layer);
    const layer = document.getElementById('tours-booking');
    if ( !layer )
      return;
    let toursData = [];
    setTimeout(() => {
      let tours = document.getElementsByClassName('tour-info');
      for( let i = 0; i < tours.length; i++ ) {
        const tour = JSON.parse(tours[i].dataset.tour);
        toursData.push(
          {
            item_id: tour.tour_id.toString(),
            item_name: tour.tour_name,
            currency: "EUR",
            index: i,
            item_category: tour.category_name,
            price: parseFloat(tour.price_plain),
            quantity: 1
          }
        );
      }
      let userInfo = document.getElementById('user-info');
      let user = {};
      if ( userInfo ) {
        userInfo = userInfo.dataset;
        user = {
          email: userInfo.email,
          first_name: userInfo.first_name,
          last_name: userInfo.last_name,
          phone_number: userInfo.phone_number,
          street: userInfo.street,
          city: userInfo.city,
          postal_code: userInfo.postal_code,
          country: userInfo.country
        }
      }

      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_name: "Tours",
          items: toursData,
          enhanced_conversion_data: user
        }
      });
      console.log('DATALAYER - view_item_list', dataLayer);
    }, 100);
  }

}